
export default function LoadingIndicator() {
    return (
        <div className="loader-wrapper">
            <div className="loader"></div>
        </div>
    )
}